// frontend/src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import { useAuthStore } from './stores/auth';
import i18n from './i18n'; // Import i18n configuration
// Import Bootstrap CSS and Icons
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
// import '@/assets/bootstrap-icons-fix.css'; // Temporarily disabled - causing compilation issues
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import axios from 'axios';
import Cookies from 'js-cookie';
// Import global stylesheet
import '@/assets/global.css';
// Import analytics service für GA User-ID
import { trackGAPageView } from './services/analyticsService';
// Import asset preloading utilities
import { preloadAllAssets } from './utils/preloadAssets';
// Import Bootstrap Icons fix
import { fixBootstrapIconsPaths, ensureFontsAvailable } from './utils/fixBootstrapIcons';
//debugger; 
// Fix Bootstrap Icons paths for production
fixBootstrapIconsPaths();

// Preload critical assets before app initialization
preloadAllAssets();

// Ensure fonts are available
ensureFontsAvailable();

// Configure Axios base URL
// Priority:
// 1) VUE_APP_API_BASE_URL (explicit override; e.g., .env.local)
// 2) DEVELOPMENT_MODE flag decides between DEV/PROD URLs
// 3) Fallbacks: localhost:5000 in dev, '/api' in prod
const toBool = (v) => String(v).trim().toLowerCase() === 'true' || v === '1';

const rawDevMode =
  typeof process.env.VUE_APP_DEVELOPMENT_MODE !== 'undefined'
    ? process.env.VUE_APP_DEVELOPMENT_MODE
    : process.env.DEVELOPMENT_MODE;

const devModeFlag =
  typeof rawDevMode !== 'undefined'
    ? toBool(rawDevMode)
    : (process.env.NODE_ENV === 'development');

const selectedFromMode = devModeFlag
  ? process.env.VUE_APP_API_BASE_URL_DEV
  : process.env.VUE_APP_API_BASE_URL_PROD;

const apiBaseUrl =
  process.env.VUE_APP_API_BASE_URL ||
  selectedFromMode ||
  (devModeFlag ? 'http://localhost:5000/api' : '/api');

axios.defaults.baseURL = apiBaseUrl;
console.log('[Axios] baseURL =', axios.defaults.baseURL);


const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
// Create the auth store instance outside of components
const authStore = useAuthStore(pinia);

// Add a request interceptor to include the JWT token
axios.interceptors.request.use(
  function(config) {
    const token = Cookies.get('access_token');
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle 401 errors
axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    if (error.response && error.response.status === 401) {
      // Not authorized, remove token and redirect to login page
      authStore.logout();
      router.push('/login');
    }
    return Promise.reject(error);
  }
);

// Initialisiere die GA User-ID beim App-Start
authStore.initGAUserId();

// Router-Hook für Page Views mit User-ID
router.afterEach((to) => {
  trackGAPageView(to.fullPath);
});

createApp(App)
  .use(router)
  .use(pinia)
  .use(i18n) // Add i18n
  .mount('#app');
